<template>
  <ul class="trainer-info__info">
    <li v-for="(value, key) in trainerData" :key="key">
      <span> {{ key }}:  </span>
      <span> {{ value }} </span>
    </li>
  </ul>  
</template>

<script>
import { getTrainerDesc } from './trainer_desc'
export default {
  props: ['trainer', 'params'],
  data() {
    return {
      trainerData: null
    }
  },
  methods: {
    getTrainerDesc
  },
  created() {
    this.trainerData = this.getTrainerDesc(this.trainer, this.params)
  },
  watch: {
    params: {
      handler: function (newValue) {
        this.trainerData = this.getTrainerDesc(this.trainer, this.params)
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
.trainer-info {
  position: relative;
  margin-left: 5px;  
}
.trainer-info__info {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  text-align: left;

  & span {
    font-size: 12px;
  }

  & li {
    font-size: 12px;
  }

  & li span:first-child {
    color: #0080DA;    
  }
}
</style>